import  { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(Tooltip, Legend, CategoryScale, LinearScale, ArcElement);

const ValueChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/learningJson`
        );
       

        const rawData = response.data.data.Data;
        

      
        const firstMonth = rawData[0]["Month"];
        const monthData = rawData.filter(
          (item) => item["Month"] === firstMonth
        );

        const parameters = [
          "Cost Ad",
          "Revenue",
          "successful calls",
          "unsuccessful calls",
          "Marketing Power",
          "Selling Power",
        ];

        const totals = parameters.map((parameter) => {
          return monthData.reduce((total, item) => total + item[parameter], 0);
        });

        const colorPalette = [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
        ];

        const borderColorPalette = [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
        ];

        const dataset = {
          label: `Distribution for ${firstMonth}`,
          data: totals,
          backgroundColor: colorPalette,
          borderColor: borderColorPalette,
          borderWidth: 1,
        };

        setChartData({
          labels: parameters,
          datasets: [dataset],
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "white", // Color for the legend text
            font: {
              size: 14, // Font size for the legend text
            },
          },
        },
      },
      elements: {
        arc: {
          borderWidth: 1,
        },
      },
      animations: {
        animateRotate: true,
        animateScale: true,
      },
      interaction: {
        mode: "nearest",
        intersect: false,
        axis: "x",
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Parameter Distribution for {chartData.datasets[0].label}
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Doughnut data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default ValueChart;
